import { GenericAbortSignal } from 'axios';

import {
  BulkPayerType,
  FacilityNetworkSummary,
  GroupPayerNetworkStatusIndex,
  NetworkStatus,
  PayerNetworkSummary,
  StatusField,
} from 'models/GroupPayerNetworkStatus';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const groupPayerNetworkStatusQueryKeys = {
  base: ['groupPayerNetworkStatuses'],
  facilities: (params: Record<string, any> = {}) => ['groupPayerNetworkStatuses', 'facilities', params],
  payers: (params: Record<string, any> = {}) => ['groupPayerNetworkStatuses', 'payers', params],
  rows: (params: Record<string, any> = {}) => ['groupPayerNetworkStatuses', 'rows', params],
};

export type NetworkStatusFilter = { stediPayerId: string } | { groupId: string };

export type NewGroupPayerNetworkStatuses = { stediPayerIds: string[]; groupIds: string[] } & Record<
  StatusField,
  NetworkStatus
>;

export async function indexFacilityNetworkSummaries(
  params: BaseIndexQueryParams & { stediPayerId?: string },
  signal: GenericAbortSignal
) {
  return http
    .get<Paginated<FacilityNetworkSummary>>('/group_payer_network_statuses/groups', { params, signal })
    .then((response) => response.data);
}

export async function indexPayerNetworkSummaries(
  params: BaseIndexQueryParams & { stediPayerIds?: string[] },
  signal: GenericAbortSignal
) {
  return http
    .get<Paginated<PayerNetworkSummary>>('/group_payer_network_statuses/payers', { params, signal })
    .then((response) => response.data);
}

export async function destroyGroupPayerNetworkStatuses(params: NetworkStatusFilter) {
  return http.delete('/group_payer_network_statuses', { params });
}

export async function indexGroupPayerNetworkStatuses(
  params: NetworkStatusFilter & { stediPayerIds?: string[] } & BaseIndexQueryParams,
  signal: GenericAbortSignal
) {
  return http
    .get<GroupPayerNetworkStatusIndex>('/group_payer_network_statuses', { params, signal })
    .then((response) => response.data);
}

export async function updateGroupPayerNetworkStatus({
  id,
  ...statuses
}: { id: string } & Partial<Record<StatusField, NetworkStatus>>) {
  return http.patch(`/group_payer_network_statuses/${id}`, statuses);
}

export async function updateGroupPayerNetworkStatuses(body: {
  ids: string[];
  payerType: BulkPayerType;
  status: NetworkStatus;
}) {
  return http.patch('/group_payer_network_statuses', body);
}

export async function destroyGroupPayerNetworkStatus(id: string) {
  return http.delete(`/group_payer_network_statuses/${id}`);
}

export async function createGroupPayerNetworkStatuses(body: NewGroupPayerNetworkStatuses) {
  return http.post('/group_payer_network_statuses', body);
}
